import AScene from '../../library/ExtendedObjects/AScene.js';
import Rivette from '../intro/Rivette.js';
import gameData from '../../gameData.js';
import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../../FontKeys.js';
import ABCyaLib from '@abcya/abcya_lib';

export default class Museum extends AScene {
  static get KEY() { return 'Museum'; }

  create() {
    this.allArtifacts = [];
    this.found = [];
    this.missing = [];

    this.combinedArtifacts = [gameData.artifacts, gameData.collectedArtifacts];

    this.bgCont = this.add.container();
    this.bg1 = this.addImage(this.mid.x, this.mid.y, "Bckg1Large");
    this.bg2 = this.addImage(this.mid.x + this.bg1.width - 2, this.mid.y, "Bckg2Large");
    this.bgCont.add([this.bg1, this.bg2]);

    this.createArtifacts();
    this.createRivette();
    this.createNavbar();

    this.addTween(this.bgCont, 3000, { x: -this.bg1.width }, Phaser.Math.Easing.Quadratic.InOut);

    for (let n = 0; n < this.found.length; n++) {
      this.addTween(this.found[n], 3000, { x: this.combinedArtifacts[1][n].x }, Phaser.Math.Easing.Quadratic.InOut);
    }
    for (let n = 0; n < this.missing.length; n++) {
      this.addTween(this.missing[n], 3000, { x: this.combinedArtifacts[0][n].x }, Phaser.Math.Easing.Quadratic.InOut);
    }

    this.addTween(this.bust1, 3000, { x: 218 }, Phaser.Math.Easing.Quadratic.InOut);
    this.addTween(this.bust2, 3000, { x: 814 }, Phaser.Math.Easing.Quadratic.InOut);
  }

  createRivette() {
    this.rivette = this.addContainer(0, 0, new Rivette(this, 1200, 530, "museum"), this);

    //hack way of preventing the "blipping effect"
    this.rivette.character.spine.setDepth(-1);
    this.addDelay(50, () => { this.tweenInRivette(); });
  }

  tweenInRivette() {
    this.rivette.character.spine.setDepth(3);

    this.addDelay(2250, () => { this.playSound("footsteps"); });

    this.addTween(this.rivette.character.spine, 1000, { x: 940, delay: 2250 }, Phaser.Math.Easing.Quadratic.Out,
      () => {
        this.rivette.playAnimation("idle", true);
        this.rivette.dialogue();
        this.enableArtifacts();
      });
  }

  createNavbar() {
    this.navBar = this.add.container();
    this.navBg = this.addImage(0, 0, "ArtifactProgressUI");
    this.navBar.add(this.navBg);

    this.collected = ABCyaPhaser.Text.addText(0, 0, 60, 0xffd50f, FontKeys._Tertre_Med, String(this.combinedArtifacts[1].length), this.navBar).setShadow(2, 2, '#222');

    if (this.collected.text.length === 1) {
      this.collected.setPosition(-this.navBg.width / 2 + 60, -25);
    } else {
      this.collected.setPosition(-this.navBg.width / 2 + 45, -25);
    }

    const outOf = ABCyaPhaser.Text.addText(30, -25, 60, 0xe2d4bc, FontKeys._Tertre_Med, "/ 20", this.navBar).setShadow(2, 2, '#222');

    const size = ABCyaLib.Environment.instance.locale === 'es-US' ? 16 : 18;
    const reminder = ABCyaPhaser.Text.addText(-10, 20, size, 0xe2d4bc, FontKeys._Tertre_Med, ABCyaPhaser.Localization.instance.getLocalizedString('museum_navBar'), this.navBar).setShadow(2, 2, '#222');
    reminder.setResolution(1.5);

    this.navBar.setPosition(-this.navBg.width / 2, this.navBg.height / 2);
    this.addTween(this.navBar, 3000, { x: this.navBg.width / 2 }, Phaser.Math.Easing.Quadratic.Out);
  }

  createArtifacts() {
    let peg1 = this.addImage(this.bg1.width + 420, 182, "WallNail");
    let peg2 = this.addImage(this.bg1.width + 580, 183, "WallNail");
    let peg3 = this.addImage(this.bg1.width + 774, 255, "WallNail");
    let peg4 = this.addImage(this.bg1.width + 410, 379, "WallNail");
    let peg5 = this.addImage(this.bg1.width + 600, 378, "WallNail");
    this.bgCont.add([peg1, peg2, peg3, peg4, peg5]);

    this.bust1 = this.addImage(this.bg1.width + 218, 464, "MannequinHeadLeft");
    this.bust2 = this.addImage(this.bg1.width + 814, 462, "MannequinHeadRight");
    this.bust1.setAlpha(.35);
    this.bust2.setAlpha(.35);

    for (let n = 0; n < this.combinedArtifacts[0].length; n++) {
      let artifact = this.addImage(this.bg1.width + this.combinedArtifacts[0][n].x, this.combinedArtifacts[0][n].y, this.combinedArtifacts[0][n].missing);
      this.allArtifacts.push(artifact);
      this.missing.push(artifact);

      if (this.combinedArtifacts[0][n].missing === "Rug_Missing") {
        artifact.setDepth(0);
      } else {
        artifact.setDepth(1);
      }
    }
    for (let n = 0; n < this.combinedArtifacts[1].length; n++) {
      let artifact = this.addImage(this.bg1.width + this.combinedArtifacts[1][n].x, this.combinedArtifacts[1][n].y, this.combinedArtifacts[1][n].small);
      this.allArtifacts.push(artifact);
      this.found.push(artifact);
      artifact.name = this.combinedArtifacts[1][n].large;

      if (this.combinedArtifacts[1][n].small === "Rug") {
        artifact.setDepth(1);
      } else if (this.combinedArtifacts[1][n].small === "Headdress") {
        this.bust1.setAlpha(1);
        artifact.setDepth(2);
        this.bust1.on("pointerup", () => { this.enlarge(this.combinedArtifacts[1][n]); });
      } else if (this.combinedArtifacts[1][n].small === "TricornHat") {
        this.bust2.setAlpha(1);
        artifact.setDepth(2);
        this.bust2.on("pointerup", () => { this.enlarge(this.combinedArtifacts[1][n]); });
      } else {
        artifact.setDepth(2);
      }

      artifact.on("pointerup", () => { this.enlarge(this.combinedArtifacts[1][n]); });
    }
  }

  enableArtifacts() {
    for (let n = 0; n < this.found.length; n++) {
      this.found[n].setInteractive();
    }

    if (this.bust1.alpha === 1) this.bust1.setInteractive();
    if (this.bust2.alpha === 1) this.bust2.setInteractive();
  }

  disableArtifacts() {
    for (let n = 0; n < this.found.length; n++) {
      this.found[n].disableInteractive();
    }

    if (this.bust1.alpha === 1) this.bust1.disableInteractive();
    if (this.bust2.alpha === 1) this.bust2.disableInteractive();
  }

  enlarge(artifact) {
    this.playSound("click");

    this.disableArtifacts();
    this.createShader();
    this.createInfo(artifact);

    this.rivette.disableBtn();

    let artX;
    let artY;
    if (artifact.dir === "landscape") {
      artX = this.mid.x;

      if (artifact.small === "Painting" || artifact.small === "RaptorSkull" || artifact.small === "Lamp" || artifact.small === "MayanMask") {
        artY = this.mid.y - 150;
      } else {
        artY = this.mid.y - 100;
      }
    } else {
      artX = this.mid.x - 200;
      artY = this.mid.y;
    }

    this.glow = this.addImage(artX, artY, "ItemGlow");
    this.glow.setScale(0, 0);
    this.glow.setDepth(4);
    this.largeArtifact = this.addImage(artX, artY, artifact.large);
    this.largeArtifact.setScale(0, 0);
    this.largeArtifact.setDepth(5);

    this.addTween(this.glow, 2000, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out);
    this.addTween(this.glow, 15000, { angle: 360, repeat: -1 }, Phaser.Math.Easing.None);
    this.addTween(this.largeArtifact, 1000, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out);
  }

  createShader() {
    let rect = new Phaser.Geom.Rectangle(0, 0, this.mid.x * 2, this.mid.y * 2);
    this.shader = this.add.graphics({ fillStyle: { color: 0x113940 } });
    this.shader.fillRectShape(rect);
    this.shader.setDepth(3);

    this.shader.alpha = 0;
    this.addTween(this.shader, 1000, { alpha: .66 }, Phaser.Math.Easing.None);
  }

  createInfo(artifact) {
    if (artifact.dir === "landscape") {
      this.infoBoard = this.add.container(this.mid.x, this.mid.y + 200);
    } else {
      this.infoBoard = this.add.container(this.mid.x + 200, this.mid.y);
    }

    let bg = this.addImage(0, 0, "MuseumPlaque", this.defaultAtlas, this.infoBoard);

    let maxFontSize = 60;
    this.title = ABCyaPhaser.Text.addText(-5, -75, maxFontSize, 0x463d38, FontKeys._Futura, ABCyaPhaser.Localization.instance.getLocalizedString(artifact.title), this.infoBoard);
    ABCyaPhaser.Text.resizeFontToFitWidth(this.title, bg.width-30, 48, maxFontSize);
    
    this.info = ABCyaPhaser.Text.addText(-10, 10, 26, 0x463d38, FontKeys._Futura, ABCyaPhaser.Localization.instance.getLocalizedString(artifact.info), this.infoBoard, false).setWordWrapWidth(bg.width - 30).setOrigin(0.5);
    ABCyaPhaser.Text.resizeFontToFitWidth(this.info, bg.width-30, 150, 26);

    this.infoBoard.setScale(0, 0);
    this.infoBoard.setDepth(5);

    this.exit = this.addImage(this.infoBoard.x, this.infoBoard.y + bg.height / 2, "CloseBtn");
    this.exit.setScale(0, 0);
    this.exit.setDepth(5);

    this.addTween(this.infoBoard, 1000, { scaleX: 1, scaleY: 1, delay: 500 }, Phaser.Math.Easing.Back.Out);
    this.addTween(this.exit, 1000, { scaleX: 1, scaleY: 1, delay: 700 }, Phaser.Math.Easing.Back.Out,
      () => {
        this.exit.setInteractive();
        this.exit.on("pointerup", () => { this.tweenOutInfo(); });
      });
  }

  tweenOutInfo() {
    this.playSound("click");

    this.exit.disableInteractive();

    this.addTween(this.infoBoard, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In);
    this.addTween(this.exit, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In);
    this.addTween(this.shader, 500, { alpha: 0 }, Phaser.Math.Easing.None);
    this.addTween(this.largeArtifact, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In);
    this.addTween(this.glow, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In,
      () => { this.clearInfo(); });
  }

  tweenOutMuseum() {
    this.playSound("click");

    this.rivette.clearDialogue();
    this.disableArtifacts();

    this.addTween(this.navBar, 2500, { x: -this.navBg.width / 2 }, Phaser.Math.Easing.Quadratic.In);
    this.addTween(this.bgCont, 3000, { x: 0 }, Phaser.Math.Easing.Quadratic.InOut,
      () => { this.cleanUp(); });

    this.rivette.character.spine.setScale(.75, .75);
    this.rivette.playAnimation("walk", true);
    this.addTween(this.rivette.character.spine, 1000, { x: 1400 }, Phaser.Math.Easing.Quadratic.In);

    for (let n = 0; n < this.found.length; n++) {
      this.addTween(this.found[n], 3000, { x: this.bg1.width + this.combinedArtifacts[1][n].x }, Phaser.Math.Easing.Quadratic.InOut);
    }
    for (let n = 0; n < this.missing.length; n++) {
      this.addTween(this.missing[n], 3000, { x: this.bg1.width + this.combinedArtifacts[0][n].x }, Phaser.Math.Easing.Quadratic.InOut);
    }

    this.addTween(this.bust1, 3000, { x: this.bg1.width + 218 }, Phaser.Math.Easing.Quadratic.InOut);
    this.addTween(this.bust2, 3000, { x: this.bg1.width + 814 }, Phaser.Math.Easing.Quadratic.InOut);
  }

  clearInfo() {
    this.killTween(this.glow);

    this.enableArtifacts();
    this.rivette.enableBtn();

    this.glow.destroy();
    this.largeArtifact.destroy();
    this.shader.destroy();
    this.exit.destroy();
    this.infoBoard.destroy();
  }

  cleanUp() {
    this.navBar.destroy();

    this.rivette.cleanUp();
    this.rivette.destroy();

    for (let n = 0; n < this.allArtifacts.length; n++) {
      this.allArtifacts[n].destroy();
    }

    this.scene.start('Intro');
  }
}